(ns iris.screens.route-data
  (:require
   [iris.screens.events :as screen-events]))


(defn- route-params [route]
  (get-in route [:route :route-params]))


(defn- query-params [route]
  (or (get-in route [:route :query-params]) {}))


(defn screens-query-params [db route]
  (assoc (query-params route)
         :clear-form? (boolean (get-in db [:screens :form-data :ruid]))))


(defn screens-load-key [query-params]
  (select-keys query-params [:q :limit :page :order :scope]))


(defn screens-effects [{:keys [q clear-form?] :as query-params}]
  (cond-> [(if q
             [::screen-events/http-search-screen-list query-params]
             [::screen-events/http-get-screen-list query-params])]
    clear-form? (conj [::screen-events/reset-form-data])))


(defn screen-edit-query-params [_db route]
  (when-let [id (:id (route-params route))]
    {:id id}))


(defn screen-edit-load-key [query-params]
  query-params)


(defn screen-edit-effects [{:keys [id]}]
  [[::screen-events/http-get-screen id]])


(defn screen-create-new-query-params [_db route]
  {:scope (:scope (query-params route))})


(defn screen-create-new-load-key [query-params]
  query-params)


(defn screen-create-new-effects [{:keys [scope]}]
  [(if scope
     [::screen-events/reset-form-data {:scopes_input scope}]
     [::screen-events/reset-form-data])])


(def panel-loaders
  {:screens-panel
   {:params-fn   screens-query-params
    :load-key-fn screens-load-key
    :effects-fn  screens-effects}

   :screens-edit-panel
   {:params-fn   screen-edit-query-params
    :load-key-fn screen-edit-load-key
    :effects-fn  screen-edit-effects}

   :screens-create-new-panel
   {:params-fn   screen-create-new-query-params
    :load-key-fn screen-create-new-load-key
    :effects-fn  screen-create-new-effects}})
